import { unities } from "@/common/constants/unities.constants";
import { ClientConsumptionData } from "@/common/types/client/consumption.type";
import { formatCurrency, formatDecimal, formatUnit } from "@/common/utils/formatters";

type ConsumptionEventableProps = {
  data: ClientConsumptionData;
};

const ConsumptionDetails = ({ data: consumption }: ConsumptionEventableProps) => {

  return (
    <div className="flex flex-col gap-3">
      <div className='flex gap-2'>
        <p className="italic">Empresa cliente:</p>
        <p className='font-bold'>{consumption?.presented_client_fantasy_name || '--'}</p>
      </div>

      {Number(consumption?.line_items?.length) > 0 && (
        <div className="flex flex-col justify-center">
          {consumption?.line_items?.map((line_item) => (
            <p key={line_item.id}>
              {line_item.product.display_name} - {formatUnit(formatDecimal(line_item.quantity, 3), line_item.product.unit_for_quantity)} - {formatCurrency(Number(line_item.amount) / Number(line_item.quantity))}/{unities[line_item.product.unit_for_quantity]}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default ConsumptionDetails;
